import {
    ANALYTICS_PINWHEEL_OPEN_HOMEPAGE,
    ANALYTICS_PINWHEEL_OPEN_CONFIRM_EMPLOYER,
    ANALYTICS_PINWHEEL_OPEN_SELECT_AMOUNT,
    ANALYTICS_PINWHEEL_OPEN_INTRO,
    ANALYTICS_PINWHEEL_OPEN_INTRO_CURRENT_DEDUCTION,
    ANALYTICS_PINWHEEL_OPEN_SUCCESS,
    ANALYTICS_PINWHEEL_CLICK_SUCCESS_INSTRUCTIONS,
    ANALYTICS_PINWHEEL_INTRO_SELECT_MANUAL_SETUP,
    ANALYTICS_PINWHEEL_INTRO_SELECT_CONTINUE,
    ANALYTICS_PINWHEEL_INTRO_INSTANT_SHIP_MODAL_VIEW,
    ANALYTICS_PINWHEEL_INTRO_INSTANT_SHIP_MODAL_CLOSE,
    ANALYTICS_PINWHEEL_EARLY_INSTANT_SHIP_MODAL_VIEW,
    ANALYTICS_PINWHEEL_EARLY_INSTANT_SHIP_MODAL_CLOSE,
    ANALYTICS_PINWHEEL_OPEN_EXIT_SURVEY,
    ANALYTICS_PINWHEEL_OPEN_ABORT_LANDING,
    ANALYTICS_PINWHEEL_SUBMIT_EXIT_SURVEY,
    ANALYTICS_PINWHEEL_OPEN_FAILURE,
    ANALYTICS_PINWHEEL_EMPLOYER_UPDATED,
    ANALYTICS_PINWHEEL_MINIMUM_PAYMENT_SELECTED,
    ANALYTICS_PINWHEEL_CUSTOM_AMOUNT_SELECTED,
    ANALYTICS_PINWHEEL_OPEN_TERMS_OF_SERVICE,
    ANALYTICS_PINWHEEL_OPEN_PRIVACY_POLICY,
    ANALYTICS_PINWHEEL_OPEN_PINWHEEL_MODAL,
    ANALYTICS_PINWHEEL_MODAL_EVENT,
    ANALYTICS_PINWHEEL_FAILURE_CLICK_VIEW_INSTRUCTIONS,
    ANALYTICS_PINWHEEL_OPEN_PINWHEEL_UNAVAILABLE,
    ANALYTICS_PINWHEEL_ABORT_LANDING_CLICK_GO_TO_INSTRUCTIONS,
    ANALYTICS_PINWHEEL_CANNOT_FIND_PROVIDER_CLICK_GO_TO_INSTRUCTIONS,
    ANALYTICS_PINWHEEL_CLICK_FINISHED_PAYROLL_INSTRUCTIONS,
    ANALYTICS_PINWHEEL_OPEN_CANNOT_FIND_PAYROLL_PROVIDER,
    ANALYTICS_PINWHEEL_CLICK_TRY_AGAIN,
    ANALYTICS_PINWHEEL_CLICK_INSTRUCTIONS_COMPLETE_DONE,
    ANALYTICS_PINWHEEL_CLICK_INSTRUCTIONS_COMPLETE_INSTRUCTIONS,
    ANALYTICS_PINWHEEL_OPEN_INSTANT_SHIP_SUCCESS,
    ANALYTICS_PINWHEEL_CLICK_DONE_INSTANT_SHIP_SUCCESS,
    ANALYTICS_PINWHEEL_NUDGE_DIRECT_DEPOSIT_AMOUNT_SELECTED,
    ANALYTICS_PINWHEEL_OPEN_NUDGE_DIRECT_DEPOSIT_SELECT_AMOUNT,
    PINWHEEL_MODAL_EVENT,
} from '@perpay-web/fintech/constants/actionTypes';

export function analyticsPinwheelOpenStepHomepage(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_HOMEPAGE,
        payload,
    };
}

export function analyticsPinwheelOpenStepAbortLanding(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_ABORT_LANDING,
        payload,
    };
}

export function analyticsPinwheelOpenStepConfirmEmployer(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_CONFIRM_EMPLOYER,
        payload,
    };
}

export function analyticsPinwheelOpenStepSelectAmount(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_SELECT_AMOUNT,
        payload,
    };
}

export function analyticsPinwheelOpenStepNudgeDirectDepositSelectAmount(
    payload,
) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_NUDGE_DIRECT_DEPOSIT_SELECT_AMOUNT,
        payload,
    };
}

export function analyticsPinwheelOpenStepIntro(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_INTRO,
        payload,
    };
}

export function analyticsPinwheelOpenStepIntroCurrentDeduction(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_INTRO_CURRENT_DEDUCTION,
        payload,
    };
}

export function analyticsPinwheelInstantShipModalView(payload) {
    return {
        type: ANALYTICS_PINWHEEL_INTRO_INSTANT_SHIP_MODAL_VIEW,
        payload,
    };
}

export function analyticsPinwheelInstantShipModalClose(payload) {
    return {
        type: ANALYTICS_PINWHEEL_INTRO_INSTANT_SHIP_MODAL_CLOSE,
        payload,
    };
}

export function analyticsPinwheelEarlyInstantShipModalView() {
    return {
        type: ANALYTICS_PINWHEEL_EARLY_INSTANT_SHIP_MODAL_VIEW,
    };
}

export function analyticsPinwheelEarlyInstantShipModalClose() {
    return {
        type: ANALYTICS_PINWHEEL_EARLY_INSTANT_SHIP_MODAL_CLOSE,
    };
}

export function analyticsPinwheelOpenStepSuccess(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_SUCCESS,
        payload,
    };
}

export function analyticsPinwheelClickSuccessInstructions(payload) {
    return {
        type: ANALYTICS_PINWHEEL_CLICK_SUCCESS_INSTRUCTIONS,
        payload,
    };
}

export function analyticsPinwheelIntroStepSelectManualSetup(payload) {
    return {
        type: ANALYTICS_PINWHEEL_INTRO_SELECT_MANUAL_SETUP,
        payload,
    };
}

export function analyticsPinwheelIntroStepSelectContinue(payload) {
    return {
        type: ANALYTICS_PINWHEEL_INTRO_SELECT_CONTINUE,
        payload,
    };
}

export function analyticsPinwheelOpenPinwheelModal(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_PINWHEEL_MODAL,
        payload,
    };
}

export function analyticsPinwheelOpenExitSurvey(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_EXIT_SURVEY,
        payload,
    };
}

export function analyticsPinwheelSubmitExitSurvey(payload) {
    return {
        type: ANALYTICS_PINWHEEL_SUBMIT_EXIT_SURVEY,
        payload,
    };
}

export function analyticsPinwheelOpenFailure(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_FAILURE,
        payload,
    };
}

export function analyticsPinwheelEmployerUpdated(payload) {
    return {
        type: ANALYTICS_PINWHEEL_EMPLOYER_UPDATED,
        payload,
    };
}

export function analyticsPinwheelMinimumPaymentSelected(payload) {
    return {
        type: ANALYTICS_PINWHEEL_MINIMUM_PAYMENT_SELECTED,
        payload,
    };
}

export function analyticsPinwheelCustomAmountSelected(payload) {
    return {
        type: ANALYTICS_PINWHEEL_CUSTOM_AMOUNT_SELECTED,
        payload,
    };
}

export function analyticsPinwheelOpenTermsOfService(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_TERMS_OF_SERVICE,
        payload,
    };
}

export function analyticsPinwheelOpenPrivacyPolicy(payload) {
    return { type: ANALYTICS_PINWHEEL_OPEN_PRIVACY_POLICY, payload };
}

export function pinwheelModalEvent(
    eventName,
    eventPayload,
    perpayModalContext,
) {
    return {
        type: PINWHEEL_MODAL_EVENT,
        payload: { eventName, eventPayload, perpayModalContext },
    };
}

export function analyticsPinwheelModalEvent({
    eventName,
    eventPayload,
    perpayModalContext,
    isNative = false,
}) {
    return {
        type: ANALYTICS_PINWHEEL_MODAL_EVENT,
        payload: { eventName, eventPayload, perpayModalContext, isNative },
    };
}

export function analyticsPinwheelFailureClickViewInstructions() {
    return {
        type: ANALYTICS_PINWHEEL_FAILURE_CLICK_VIEW_INSTRUCTIONS,
    };
}

export function analyticsPinwheelOpenPinwheelUnavailable() {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_PINWHEEL_UNAVAILABLE,
    };
}

export function analyticsPinwheelAbortLandingClickGoToInstructions() {
    return {
        type: ANALYTICS_PINWHEEL_ABORT_LANDING_CLICK_GO_TO_INSTRUCTIONS,
    };
}

export function analyticsPinwheelClickFinishedPayrollInstructions() {
    return {
        type: ANALYTICS_PINWHEEL_CLICK_FINISHED_PAYROLL_INSTRUCTIONS,
    };
}

export function analyticsPinwheelOpenCannotFindPayrollProvider(payload) {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_CANNOT_FIND_PAYROLL_PROVIDER,
        payload,
    };
}

export function analyticsPinwheelClickTryAgain() {
    return {
        type: ANALYTICS_PINWHEEL_CLICK_TRY_AGAIN,
    };
}

export function analyticsPinwheelCannotFindProviderClickGoToInstructions() {
    return {
        type: ANALYTICS_PINWHEEL_CANNOT_FIND_PROVIDER_CLICK_GO_TO_INSTRUCTIONS,
    };
}

export function analyticsPinwheelClickInstructionsCompleteDone() {
    return {
        type: ANALYTICS_PINWHEEL_CLICK_INSTRUCTIONS_COMPLETE_DONE,
    };
}
export function analyticsPinwheelClickInstructionsCompleteInstructions() {
    return {
        type: ANALYTICS_PINWHEEL_CLICK_INSTRUCTIONS_COMPLETE_INSTRUCTIONS,
    };
}

export function analyticsPinwheelOpenInstantShipSuccess() {
    return {
        type: ANALYTICS_PINWHEEL_OPEN_INSTANT_SHIP_SUCCESS,
    };
}

export function analyticsPinwheelClickDoneInstantShipSuccess() {
    return {
        type: ANALYTICS_PINWHEEL_CLICK_DONE_INSTANT_SHIP_SUCCESS,
    };
}

export function analyticsPinwheelNudgeDirectDepositAmountSelected(payload) {
    return {
        type: ANALYTICS_PINWHEEL_NUDGE_DIRECT_DEPOSIT_AMOUNT_SELECTED,
        payload,
    };
}
